import {
    ChevronRight,
    ChevronLeft,
    RightDarkBackgroundIcon,
    LeftDarkBackgroundIcon,
} from '../../icons'
import {BRAND_KEY} from '../../../brand'

const ICON_ARROWS = {
    default: {right: ChevronRight, left: ChevronLeft},
    braun: {right: RightDarkBackgroundIcon, left: LeftDarkBackgroundIcon},
}

export default ICON_ARROWS[BRAND_KEY] ?? ICON_ARROWS.default
